/*
* This reducer file handles reducer's state for all actions that are related to subscription
*/
const initialState={
    plans:[],
    selected_subscription:false,
    tnc_text:'',
    subscription_updated:false,
    upgradeDowngradeText: '',
    free_trial_end: false,
    extend_free_trail : false,
    trail_end_updated: false,
    sca_data:{},
    updated_plan:null,
    upgradeRequesting:false

}

export default function subscriptionsReducer(state=initialState,action){
    switch(action.type){
        case 'FETCH_SUBSCRIPTIONS_REQUEST':
            return state;
        case 'FETCH_SUBSCRIPTIONS_SUCCESS':
            return Object.assign({},state,{
                plans: action.subscriptions
            });
        case 'SELECT_SUBSCRIPTION':
            return Object.assign({},state,{
                selected_subscription:action.selectedSubscription,
                upgradeDowngradeText: action.upgradeDowngradeText
            });
        case 'TOGGLE_TNC_ERROR':
            return Object.assign({},state,{
                tnc_text:action.text
            });
        case 'SET_COMPANY_SUBSCRIPTION_REQUEST':
            return Object.assign({},state,{
                upgradeRequesting:true
            });
        case 'SET_COMPANY_SUBSCRIPTION_SUCCESS':
            return Object.assign({},state,{
                subscription_updated:action.updated,
                updated_plan:action.subscription_id,
                sca_data: action.sca_data,
                upgradeRequesting:false
            });
        case 'SET_COMPANY_SUBSCRIPTION_FAIL':
            return Object.assign({},state,{
                upgradeRequesting:false
            });
        case 'RESET_COMPANY_SUBSCRIPTION_SUCCESS':
            return Object.assign({},state,{
                subscription_updated:action.updated,
                sca_data: {},
            });
        case 'FAILED_COMPANY_SUBSCRIPTION_SUCCESS':
        return Object.assign({},state,{
            updated_plan:null,
            sca_data: {},
        });
        case 'SUBSCRIPTION_UPDATE':
            return Object.assign({},state,{
                subscription_updated:action.status
            });
        case 'SET_UPDATE_FROM_FREETRIAL_SUCCESS':
            return Object.assign({},state,{
                free_trial_end: true
            });
        case 'SET_EXTEND_FREETRIAL_SUCCESS':
            return Object.assign({},state,{
                extend_free_trail: true,
                subscriptionsHistory: action.subscriptionAllowanceUpdate
            });
        case 'NEW_SUBS_HISTORY_DATA': // to get company trail end date and allowance in admin panel
            return Object.assign({}, state, {
                trail_end_updated: true,
                newSubsData: action.subs_history_Data,
                allJobs: action.jobs_data,
                allJobsCount: action.allJobsCount
            });
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/Reducers/subscriptions.js